import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, AfterViewInit } from '@angular/core';
import { ViewboxOption } from 'src/app/models/viewboxOption.model';
import { Subject } from 'rxjs';
import { OptionPage } from 'src/app/models/OptionPage.model';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-isomasters-paging',
  templateUrl: './isomasters-paging.component.html',
  styleUrls: ['./isomasters-paging.component.scss'],
})
export class IsomastersPagingComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() elementIHaveToPage: Element;
  _options: ViewboxOption<any>[] = [];

  get options(): ViewboxOption<any>[] {
    return this._options;
  }

  @Input() set options(value: ViewboxOption<any>[]) {
    this._options = value;
    this.pageArray = [];

    if (this._options === undefined) {
      return;
    }

    for (let i = 0; i < Math.ceil(this._options.length / 2); i++) {
      const optionPage = { active: false, pageItems: [], index: i };

      for (let j = 0; j < 2; j++) {
        if (this._options[i * 2 + j]) {
          if (this._options[i * 2 + j].selected) {
            optionPage.active = true;
          }
          optionPage.pageItems.push(this._options[i * 2 + j]);
        }
      }

      this.pageArray.push(optionPage);
    }

    this._options.forEach((o: ViewboxOption<any>) => {
      o.selected$.pipe(takeUntil(this.unsubscribe)).subscribe(selected => {
        if (selected) {
          const page = this.pages.find(p => p.pageItems.some(pi => pi.selected));

          if (page) {
            this.gotoPage(page);
          }
        }
      });
    });
  }

  private pageArray: OptionPage[] = [];

  @Output() pageActivated$: EventEmitter<OptionPage> = new EventEmitter<OptionPage>();
  private unsubscribe: Subject<void> = new Subject();

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.pageActivated$.emit(this.currentPage);
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.unsubscribe();
  }

  get pages(): OptionPage[] {
    return this.pageArray;
  }

  get currentPage(): OptionPage {
    const currentPage = this.pages.find(p => p.active === true);
    if (currentPage) {
      return currentPage;
    }
    if (this.pages.length > 0) {
      this.pages[0].active = true;
      return this.pages[0];
    }
    return new OptionPage();
  }

  get currentPageOptions(): ViewboxOption<any>[] {
    if (this.currentPage && this.currentPage.pageItems) {
      return this.currentPage.pageItems;
    } else {
      return [];
    }
  }

  goBack() {
    const previousPage = this.pages.find(p => p.index === this.currentPage.index - 1);

    if (previousPage) {
      this.currentPage.active = false;
      previousPage.active = true;
      this.pageActivated$.emit(this.currentPage);
    } else {
      this.gotoLastPage();
    }
  }

  gotoLastPage() {
    this.gotoPage(this.pages[this.pages.length - 1]);
  }

  gotoFirstPage() {
    this.gotoPage(this.pages[0]);
  }

  goForward() {
    const nextPage = this.pages.find(p => p.index === this.currentPage.index + 1);

    if (nextPage) {
      this.currentPage.active = false;
      nextPage.active = true;
      this.pageActivated$.emit(this.currentPage);
    } else {
      this.gotoFirstPage();
    }
  }

  gotoPage(page: OptionPage) {
    this.currentPage.active = false;
    page.active = true;
    this.pageActivated$.emit(this.currentPage);
  }
}
